import * as endpoints from './endpoints';

const LabService = { ...endpoints };

export default LabService;
export type { OrderLabInput } from './endpoints';
